export function getScale(start, end) {
  const oneStep = 10 ** (Math.floor(Math.log10(end - start)) - 1);
  const stepNum = (end - start) / oneStep;
  const stepMul = stepMulBuilder(stepNum);
  const containStep = oneStep * stepMul ;
  const startStepNum = Math.ceil(start / containStep);
  const endStepNum = Math.floor(end / containStep);
  const startEdge = start / containStep;
  const endEdge = end / containStep;
  const safetyMargin = 0.25;
  const scales = [];
  const subScales = [];
  const SUB_SCALE_NUM = stepMul == 2 ? 4 : 5;

  const roundPrecision = (val) => {
    return Number(val.toPrecision(12));
  };

  for (let scale = startStepNum - 1; scale <= endStepNum; scale++) {
    //主目盛りの生成
    if (scale < startEdge || scale > endEdge) {
      //描画ゾーンを超えるのなら描画しない
    }
    //描画すれすれなら値の表示はしない
    else if (
      scale - startEdge < safetyMargin ||
      endEdge - scale < safetyMargin
    ) {
      scales.push({ value: "", pos: scale * containStep });
    } else {
      scales.push({
        value: String(roundPrecision(scale * containStep)),
        pos: scale * containStep,
      });
    }
    //副目盛りの生成
    for (let subScale = 1; subScale < SUB_SCALE_NUM; subScale++) {
      const subSc = scale + subScale / SUB_SCALE_NUM;
      if (subSc < startEdge || subSc > endEdge) {
        //描画ゾーンを超えるのなら描画しない
      } else {
        subScales.push({
          value: String(subSc * containStep),
          pos: subSc * containStep,
        });
      }
    }
  }
  return [scales, subScales];
}
/*
return [mainScales, subScales]

mainScales = [{ value, pos }]
subScales = [{ value, pos }]
*/
export function getLogScale(start, end) {
  if (start <= 0 || end <= 0 || start >= end) {
    return [[], []];
  }

  const scales = [];
  const subScales = [];

  const startExp = Math.ceil(Math.log10(start));
  const endExp = Math.floor(Math.log10(end));

  const safetyMargin = 0.1;

  const logStart = Math.log10(start);
  const logEnd = Math.log10(end);
  const logRange = logEnd - logStart;

  const expNum = endExp-startExp
  const goodExp = 10**(Math.floor(Math.log10(expNum)-1))
  const mainScaleNum = Math.floor(expNum/goodExp)
  const stepMul = stepMulBuilder(mainScaleNum)
  const containStep = goodExp * stepMul ;
  const dispExp = containStep
  const subScaleExp = dispExp >= 5 ? containStep/5 : 1
  // const dispExp = Math.ceil((endExp - (startExp - 1)) / 10);


  const superscript = {
    0: "⁰",
    1: "¹",
    2: "²",
    3: "³",
    4: "⁴",
    5: "⁵",
    6: "⁶",
    7: "⁷",
    8: "⁸",
    9: "⁹",
    "-": "⁻",
  };

  function expToString(exp) {
    return [...String(exp)].map((c) => superscript[c] ?? c).join("");
  }

  function logLabel(value) {
    return `10${expToString(value)}`;
  }

  for (let exp = startExp - 1; exp <= endExp; exp++) {
    const main = 10 ** exp;

    // 端に近すぎるラベルは非表示
    const ratio = (Math.log10(main) - logStart) / logRange;

    if (main >= start && main <= end && exp % dispExp === 0) {
      scales.push({
        value:
          ratio < safetyMargin || ratio > 1 - safetyMargin ? "" : logLabel(exp),
        pos: main,
      });
    } else if (main >= start && main <= end && exp % subScaleExp === 0) {
      subScales.push({
        value: "",
        pos: main,
      });
    }

    if (dispExp <= 1) {
      // 副目盛り
      for (let i = 2; i < 10; i++) {
        const sub = i * 10 ** exp;

        if (sub < start || sub > end) continue;

        subScales.push({
          value: "",
          pos: sub,
        });
      }
    }
  }

  return [scales, subScales];
}

function stepMulBuilder(stepNum) {
  if (stepNum >= 50) return 10;
  if (stepNum >= 20) return 5
  if (stepNum >= 10) return 2;
  return 1;
}
